import axiosInstance from "../../../../setup/axios/SetupAxios";
import axios from 'axios';

const API_URL = process.env.REACT_APP_BASE_URL;

export const SET_EMERGENGY_PIN_CODE_URL = `${API_URL}/api/v1/parent/pin`;
export const FORGOT_PIN_URL = `${API_URL}/api/v1/parent/forgot-pin`;
export const CHANGE_PIN_URL = `${API_URL}/api/v1/parent/change-pincode`;

function getHeader(accessToken) {
    const timezone = new Date().getTimezoneOffset();
    const headers = {
        Authorization: accessToken,
        language: 'en',
        version_code: 20000,
        timezone_offset: -1 * timezone
    }

    return headers;
}

export function setupEmergencyPincode(payload) {
    return axios({
        url: SET_EMERGENGY_PIN_CODE_URL,
        method: "POST",
        headers: getHeader(payload.accessToken),
        data: payload.appLoginPin ? { appLoginPin: payload.appLoginPin } : { deviceAttachPin: payload.deviceAttachPin , deviceAttachQrCode: payload.deviceAttachPin.toString(), kidId: payload.kidId}
    })
}

export function forgotPinCode(email, accessToken) {
    return axios({
        url: FORGOT_PIN_URL,
        method: "POST",
        headers: getHeader(accessToken),
        data: { email, isForgot: 1 }
    })
}

export function changePincode(payload) {
    return axiosInstance({
        url: CHANGE_PIN_URL,
        method: "POST",
        data: payload
    })
}